import { __awaiter, __generator } from "tslib";
import localforage from "localforage";
var FILTER_STAFF_CACHE_KEY = 'filter_staff_cache';
var FILTER_DEPARTMENT_CACHE_KEY = 'filter_department_cache';
export var setStaffs = function (staffs) { return __awaiter(void 0, void 0, void 0, function () {
    var cache_staffs;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(staffs === null || staffs === void 0 ? void 0 : staffs.length))
                    return [2];
                return [4, localforage.getItem(FILTER_STAFF_CACHE_KEY)];
            case 1:
                cache_staffs = (_a = _b.sent()) !== null && _a !== void 0 ? _a : {};
                staffs.forEach(function (item) {
                    cache_staffs["" + item.id] = item;
                });
                return [4, localforage.setItem(FILTER_STAFF_CACHE_KEY, cache_staffs)];
            case 2:
                _b.sent();
                return [2];
        }
    });
}); };
export var getStaffs = function (ids) { return __awaiter(void 0, void 0, void 0, function () {
    var cache_staffs, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
                    return [2, []];
                }
                return [4, localforage.getItem(FILTER_STAFF_CACHE_KEY)];
            case 1:
                cache_staffs = (_a = _b.sent()) !== null && _a !== void 0 ? _a : {};
                result = [];
                ids.forEach(function (id) {
                    result.push(cache_staffs[id]);
                });
                return [2, result];
        }
    });
}); };
export var setDepartmentCache = function (departments) { return __awaiter(void 0, void 0, void 0, function () {
    var cache_departments;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(departments === null || departments === void 0 ? void 0 : departments.length))
                    return [2];
                return [4, localforage.getItem(FILTER_DEPARTMENT_CACHE_KEY)];
            case 1:
                cache_departments = (_a = _b.sent()) !== null && _a !== void 0 ? _a : {};
                departments.forEach(function (item) {
                    cache_departments["" + item.id] = item;
                });
                return [4, localforage.setItem(FILTER_DEPARTMENT_CACHE_KEY, cache_departments)];
            case 2:
                _b.sent();
                return [2];
        }
    });
}); };
export var getDepartmentsFromCache = function (ids) { return __awaiter(void 0, void 0, void 0, function () {
    var cache_staffs, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
                    return [2, []];
                }
                return [4, localforage.getItem(FILTER_DEPARTMENT_CACHE_KEY)];
            case 1:
                cache_staffs = (_a = _b.sent()) !== null && _a !== void 0 ? _a : {};
                result = [];
                ids.forEach(function (id) {
                    result.push(cache_staffs[id]);
                });
                return [2, result];
        }
    });
}); };
